import Loyalty from "@material-ui/icons/Loyalty";

export const TagIcon = Loyalty;

export { TagCreate } from "./create";
export { TagEdit } from "./edit";
export { TagList } from "./list";
